import React from 'react';
import ghostLogo from '../../assets/images/brand/ghost_logo.svg';
import ghostHero from '../../assets/images/screens/ghost_hero.webp';
// import ghostValue1 from '../../assets/images/screens/ghost_hero.webp';
// import ghostValue2 from '../../assets/images/screens/ghost_hero.webp';
// import ghostValue3 from '../../assets/images/screens/ghost_hero.webp';
import { useNavigate } from 'react-router-dom';
import './Home.css';
  
export default function Home({ user }) {
  const navigate = useNavigate();

  return (
    <div id="home-wrap">
      <div>
        <div className="home-main">
          <div id="home-hero">
            <div id="hero-top">
              <div className="home-logo">
                <img src={ghostLogo} alt="Ghost Logo" />  
              </div>
              <div className="top-cta">
                <button
                  type="button"
                  className={user ? 'primary' : ''}
                  onClick={() => navigate(user ? '/projects' : '/auth/signin')}
                >
                  Sign in
                </button>
                {!user && (
                  <button type="button" className="primary" onClick={() => navigate('/auth/signup')}>
                    Try Ghost
                  </button>
                )}
              </div>
            </div>
            <div id="hero-text">
              <h1>Your new workspace for creative thinking</h1>
              <p>Your personal AI collaborator to develop ideas, gather inspiration, and turn scattered thoughts into original work, all in one focused interface.</p>  
            </div>
            <div id="hero-image">
              <img src={ghostHero} alt="Ghost Hero" />
            </div>          
          </div>

          {/*
          <div id="home-value">
            <div className="value-item">
              <div className="value-text">
                <h3>Your invisible writing partner</h3>
                <p>Ghost works beside you, quietly shaping ideas as they form. Always present, never in the way.</p>
                <p>Bounce ideas, explore alternatives, and refine tone as you go.</p>
                <p><b>Your voice stays yours. Ghost helps bring it into focus.</b></p>
              </div>
              <div className="value-image">
                <img src={ghostValue1} alt="Ghost Value 1" />
              </div>
            </div>
            <div className="value-item">
              <div className="value-image">
                <img src={ghostValue2} alt="Ghost Value 2" />
              </div>
              <div className="value-text">
                <h3>Your personal creative library</h3>
                <p>Every document you save in Ghost becomes part of your creative memory.</p>
                <p>AI can explore your work in context, connect ideas, and help you build on what you’ve already created.</p>
                <p><b>The more you write, the more powerful it becomes.</b></p>
              </div>
            </div>
            <div className="value-item">
              <div className="value-text">
                <h3>One workspace. Zero switching.</h3>
                <p>Creative projects are messy, but your tools shouldn’t be.</p>
                <p>Copy, compare, and collaborate across documents without juggling apps or losing context.</p>
                <p><b>Less busywork. More creative flow.</b></p>
              </div>
              <div className="value-image">
                <img src={ghostValue3} alt="Ghost Value 3" />
              </div>
            </div>
          </div>
          */}

          
        </div>
      </div>

      <div id="home-for">
        <div className="home-main">
          <div>
            <h2>For innovators, planners, and explorers</h2>
          </div>
          <div className="for-list">
            <div>
              <h3>Writers and creators</h3>
              <p>Develop long-form work, articles, and essays while keeping drafts, references, and ideas together.</p>
            </div>
            <div>
              <h3>Founders and product teams</h3>
              <p>Shape narratives, strategy, and positioning across multiple documents in one focused workspace.</p>
            </div> 
            <div>
              <h3>Researchers and thinkers</h3>
              <p>Collect sources, summaries, and insights, then turn them into original writing without losing context.</p>
            </div>
            <div>
              <h3>Everyday organizers</h3>
              <p>Save notes, recipes, and reference materials in one place so you can find and reuse them instantly.</p>
            </div>                                  
          </div>
        </div>
      </div>

    </div>

  );
}
